import { controls } from "../../controls";

const rp1079 = {
  label: "CCB-4A:MSC/YES",
  pageLabel: "CCB-4A:MSC/YES",
  starting: true,
  url: "rp1079",
  //formActions: { edit: { allow: true }, delete: { allow: true }, audit: { allow: true } },
  pageType: "history", //pageType: "report",
  // formTabs: {
  //   allTabs: [
  //     {
  //       label: "Basic Info",
  //       uid: "create",
  //       style: { fontFamily: "verdana" }
  //     }
  //   ]
  // },
  filter: [

    ...controls.displayText({tab:"Modal",label: "GL Sub Head",width:"col-sm-2"}),
    ...controls.product({tab: "Modal"}),
    ...controls.showData({tab:"Modal",data: "product_code_display", name: "product_code_display",width:"col-sm-2",displaytype:'camelcase'}),

    ...controls.displayText({tab: "filter",label: "As On Date",star:true,width:"col-sm-2 "}),
    ...controls.magicDate({tab: "filter",name:"as_on_date",isRequired:true,width:"col-sm-2"}),
    
    ...controls.displayText({tab: "filter",label: "",width:"col-sm-2 "}),

    ...controls.displayText({tab: "filter",label: "Three Years Ago",star:true,width:"col-sm-2 "}),
    ...controls.magicDate({tab: "filter",name:"three_month_ago",isRequired:true,width:"col-sm-2"}),
    
    ...controls.displayText({tab: "filter",label: "",width:"col-sm-2 "}),

    ...controls.displayText({tab: "filter",label: "One Year Ago",star:true,width:"col-sm-2 "}),
    ...controls.magicDate({tab: "filter",name:"one_year_ago",isRequired:true,width:"col-sm-2"}),
    
    ...controls.displayText({tab: "filter",label: "",width:"col-sm-2 "}),

    ...controls.displayText({tab: "filter",label: "Six Month Ago",star:true,width:"col-sm-2 "}),
    ...controls.magicDate({tab: "filter",name:"six_month_ago",isRequired:true,width:"col-sm-2"}),
    
    ...controls.displayText({tab: "filter",label: "",width:"col-sm-2 "}),

    ...controls.displayText({tab: "filter",label: "Three Month Ago",star:true,width:"col-sm-2 "}),
    ...controls.magicDate({tab: "filter",name:"three_month_ago",isRequired:true,width:"col-sm-2"}),
    
    ...controls.displayText({tab: "filter",label: "",width:"col-sm-2 "}),

  ],

  //form: [
  //  ...controls.displayText({ label: "Crop Type Code", width: "col-sm-1", star: true }),
  //  ...controls.text({ name: "crop_type", isRequired: true }),
  //  ...controls.displayText({ width: "col-sm-3" }),

  //  ...controls.displayText({ label: "Crop Type Desc", width: "col-sm-1", star: true }),
  //  ...controls.text({ name: "crop_type_display", isRequired: true }),
  //  ...controls.displayText({ width: "col-sm-3" }),

  //],
  form:[],

  history: {
    perPage: 10,
    reportHeader: "CCB-4A:Total Position of MSC Bank A/C",
    pdfProps: { pageSize: "A4", pageOrientation: "landscape" },
    displayColumns: [
      {
        Header: "Period",
        accessor: "period_code",
        width: 150,
        rwidth: 100
      },
      {
        Header: "Debit",
        columns: [
          {
            Header: "No of Entries",
            accessor: "no_of_entries_debit",
            rwidth:"*"
          },
          {
            Header: "Amount Rs",
            accessor: "amount_debit",
            Type: "currency",
            rwidth:"*"
          }
        ]
      },
      {
        Header: "Credit",
        columns: [
          {
            Header: "No of Entries",
            accessor: "no_of_entries_credit",
            rwidth:"*"
          },
          {
            Header: "Amount Rs",
            accessor: "amount_credit",
            Type: "currency",
            rwidth:"*"
          }
        ]
      },            
    ]
  }
};

export default rp1079;